import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import DoneModal from '../generic/modals/DoneModal'
import { FlexRowDiv, ModalContentNormal } from '../generic/Basics'
import { fontSize2XSmall, goldLight10 } from '../../constants/principles'
import ExclamationTriangle from '../generic/ExclamationTriangle'
import { LandingPageNumber, VehiclePageNumber } from '../../constants'
import { isOfferVehicleConfigMisMatch, cadsFlagsOfferVinDecodeMisMatch, isCadsUsedForOfferOrVinResults } from '../../utils/cadsUtils'
import { isVrsConfigMismatch } from '../../utils/vrsUtils'

export default ({ setShowModal, updateGlobalState, globalState, urlState, offer, navigatePageWithState, trims, trim, plateStateVinError, vinModalInfo, vinResults }) => {
  const { misMatch } = vinModalInfo
  const trimMismatchOverride = offer && offer.prospect.vehicle.vin && offer.prospect.vehicle.vin === urlState.vin && !plateStateVinError && !globalState.resetTrim
  const cadsUsed = isCadsUsedForOfferOrVinResults(offer, vinResults)
  const cadsMismatchOverride = cadsFlagsOfferVinDecodeMisMatch(offer, vinResults) && isOfferVehicleConfigMisMatch(offer, vinResults)
  const vrsMismatchOverride = isVrsConfigMismatch(offer, vinResults, cadsUsed)
  const showGenericModal = cadsMismatchOverride || vrsMismatchOverride
  const open = (cadsMismatchOverride && !misMatch && !globalState.hasShownMisMatchPopup) || (vrsMismatchOverride && !misMatch && !globalState.hasShownMisMatchPopup) || (trimMismatchOverride && misMatch)

  useEffect(() => {
    if (open) setShowModal(true)
  }, [open])

  return (
    <DoneModal
      name={'TrimModal'}
      buttonOverride={'Continue'}
      open={open}
      closeOnClickOutside={false}
      onClick={e => {
        if (!globalState.origResetTrim || !globalState.origResetTrim.resetTrim) {
          updateGlobalState({ origResetTrim: { resetTrim: globalState.resetTrim, origResetTrim: undefined } })
        }

        if (urlState && urlState.pa && urlState.pa[0] !== 'reviewoffer') navigatePageWithState({ p: trims && trims.length > 1 ? LandingPageNumber : VehiclePageNumber, resetTrim: true }, urlState)
        updateGlobalState({ resetTrim: true, hasShownMisMatchPopup: true })
        setShowModal(false)
      }}
      title={
        <FlexRowDiv>
          <StyledTriangle>
            <ExclamationTriangle colorFill={goldLight10} width={24} height={24} />
          </StyledTriangle>
          Please Note
        </FlexRowDiv>
      }>
      <ModalContentNormal>
        {showGenericModal ? (
          <>
            <P>Some of the vehicle details may have been updated based on the latest information we have related to the VIN provided.</P>
            <P>
              <strong>Please review and make any additional updates that might be needed.</strong>
            </P>
          </>
        ) : (
          <>
            <P>We've updated the style (trim) for this vehicle.</P>
            <P>Previously Reported Style: {offer && offer.prospect.vehicle.vehicleDescription.trim}</P>
            <P>Updated Style: {trims && trims.length > 1 ? 'Please update.' : trim && trim.displayName}</P>
            <P>You will need to re-select certain items like color and features.</P>
            <P>
              <strong>Please confirm the accuracy of all selections.</strong>
            </P>
          </>
        )}
      </ModalContentNormal>
    </DoneModal>
  )
}

const P = styled.p`
  font-size: ${fontSize2XSmall};
`
const StyledTriangle = styled(FlexRowDiv)`
  padding-right: 8px;
`
